import {
  // Go Live
  GO_LIVE_START,
  GO_LIVE_SUCCESS,
  GO_LIVE_FAILURE,
  // Streamer Channel
  SET_STREAMER_CHANNEL,
  FETCH_STREAMER_CHANNEL_START,
  SET_STREAMER_CHANNEL_LOADING,
  FETCH_STREAMER_CHANNEL_FAILURE,
  FETCH_STREAMER_CHANNEL_SUCCESS,
  // Streaming Channel
  SET_STREAMING_CHANNEL_IS_PAID,
  FETCH_LIVE_STREAMING_CHANNEL_START,
  FETCH_LIVE_STREAMING_CHANNEL_FAILURE,
  FETCH_LIVE_STREAMING_CHANNEL_SUCCESS,
  // Streaming Messages
  SET_LIVE_STREAMING_CHANNEL_MESSAGES,
  APPEND_LIVE_STREAMING_CHANNEL_MESSAGE,
  // Live Streaming Channels
  FETCH_LIVE_STREAMING_CHANNELS_START,
  FETCH_LIVE_STREAMING_CHANNELS_SUCCESS,
  FETCH_LIVE_STREAMING_CHANNELS_FAILURE,
  // Fetch Live Performers
  FETCH_LIVE_PERFORMERS_START,
  FETCH_LIVE_PERFORMERS_SUCCESS,
  FETCH_LIVE_PERFORMERS_FAILURE,
  // Streaming Channel Payment
  LIVE_STREAMING_CHANNEL_PAYMENT_START,
  LIVE_STREAMING_CHANNEL_PAYMENT_FAILURE,
  LIVE_STREAMING_CHANNEL_PAYMENT_SUCCESS,
  // Streaming Summary
  FETCH_LIVE_STREAMING_SUMMARY_START,
  FETCH_LIVE_STREAMING_SUMMARY_SUCCESS,
  FETCH_LIVE_STREAMING_SUMMARY_FAILURE,
  // Live Streaming Tip Payment
  ADD_LIVE_STREAMING_TIP_PAYMENT,
  REMOVE_LIVE_STREAMING_TIP_PAYMENT
} from "../actions/ActionConstant";
import { mergeUnique } from "../../helpers/array/array";

const initialState = {
  goLive: {
    data: {},
    error: false,
    inputData: {},
    loading: false
  },
  channelPaymentByWallet: {
    data: {},
    error: false,
    inputData: {},
    loading: false
  },
  streamerChannel: {
    data: {},
    error: null,
    loading: false
  },
  streamingChannel: {
    data: {},
    error: null,
    loading: false,
    is_paid: false
  },
  messages: {
    data: [],
    error: null,
    loading: false
  },
  liveChannels: {
    data: {},
    error: null,
    loading: false
  },
  livePerformers: {
    data: {},
    error: null,
    loading: false
  },
  summary: {
    data: {},
    error: null,
    loading: false
  },
  tipAnimations: {
    payments: []
  }
};

const StreamingReducer = (state = initialState, action) => {
  switch (action.type) {
    // Streamer Channel
    case SET_STREAMER_CHANNEL:
      return {
        ...state,
        streamerChannel: {
          ...state.streamerChannel,
          loading: false,
          data: action.data,
        },
      };
    case FETCH_STREAMER_CHANNEL_START:
      return {
        ...state,
        streamerChannel: {
          data: {},
          error: false,
          loading: true,
        },
      };
    case SET_STREAMER_CHANNEL_LOADING:
      return {
        ...state,
        streamerChannel: {
          ...state.streamerChannel,
          loading: action.data,
        },
      };
    case FETCH_STREAMER_CHANNEL_SUCCESS:
      return {
        ...state,
        streamerChannel: {
          ...state.streamerChannel,
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FETCH_STREAMER_CHANNEL_FAILURE:
      return {
        ...state,
        streamerChannel: {
          ...state.streamerChannel,
          data: {},
          loading: false,
          error: action.error,
        },
      };
    // Streaming Channel
    case FETCH_LIVE_STREAMING_CHANNEL_START:
      return {
        ...state,
        streamingChannel: {
          ...state.streamingChannel,
          error: null,
          loading: true
        }
      };
    case FETCH_LIVE_STREAMING_CHANNEL_SUCCESS:
      return {
        ...state,
        streamingChannel: {
          ...state.streamingChannel,
          error: null,
          loading: false,
          data: action.data
        }
      };
    case FETCH_LIVE_STREAMING_CHANNEL_FAILURE:
      return {
        ...state,
        streamingChannel: {
          ...state.streamingChannel,
          data: null,
          loading: false,
          error: action.data
        }
      };
    case SET_STREAMING_CHANNEL_IS_PAID:
      return {
        ...state,
        streamingChannel: {
          ...state.streamingChannel,
          is_paid: action.data
        }
      };
    case SET_LIVE_STREAMING_CHANNEL_MESSAGES:
      return {
        ...state,
        messages: {
          error: null,
          loading: false,
          data: action.data.reverse(),
        },
      };
    case APPEND_LIVE_STREAMING_CHANNEL_MESSAGE:
      return {
        ...state,
        messages: {
          error: null,
          loading: false,
          data: [...state.messages.data, action.data],
        },
      };
    case GO_LIVE_START:
      return {
        ...state,
        goLive: {
          data: {},
          error: false,
          inputData: {},
          loading: true,
        },
      };
    case GO_LIVE_SUCCESS:
      return {
        ...state,
        goLive: {
          data: action.data,
          error: false,
          inputData: {},
          loading: false,
        },
      };
    case GO_LIVE_FAILURE:
      return {
        ...state,
        goLive: {
          data: null,
          error: action.data,
          inputData: {},
          loading: false,
        },
      };
    case LIVE_STREAMING_CHANNEL_PAYMENT_START:
      return {
        ...state,
        channelPaymentByWallet: {
          data: {},
          error: false,
          inputData: {},
          loading: true,
        },
      };
    case LIVE_STREAMING_CHANNEL_PAYMENT_SUCCESS:
      return {
        ...state,
        channelPaymentByWallet: {
          data: action.data,
          error: false,
          inputData: {},
          loading: false,
        },
      };
    case LIVE_STREAMING_CHANNEL_PAYMENT_FAILURE:
      return {
        ...state,
        channelPaymentByWallet: {
          data: null,
          error: action.data,
          inputData: {},
          loading: false,
        },
      };
    case FETCH_LIVE_STREAMING_CHANNELS_START:
      return {
        ...state,
        liveChannels: action.data.page
          ? {
              ...state.liveChannels,
              error: null,
              loading: true,
            }
          : {
              data: {},
              error: null,
              loading: true,
            },
      };
    case FETCH_LIVE_STREAMING_CHANNELS_SUCCESS:
      const currentChannels = state.liveChannels?.data?.result || [];
      const fetchedChannels =
        action.data && action.data.result ? action.data.result : [];
      return {
        ...state,
        liveChannels: {
          data: {
            ...action.data,
            result: mergeUnique(currentChannels, fetchedChannels),
          },
          error: false,
          loading: false,
        },
      };
    case FETCH_LIVE_STREAMING_CHANNELS_FAILURE:
      return {
        ...state,
        liveChannels: {
          ...state.liveChannels,
          loading: false,
          error: action.error,
        },
      };
    case FETCH_LIVE_PERFORMERS_START:
      return {
        ...state,
        livePerformers: action.data.page
          ? {
            ...state.livePerformers,
            error: null,
            loading: true,
          }
          : {
            data: {},
            error: null,
            loading: true,
          },
      };
    case FETCH_LIVE_PERFORMERS_SUCCESS:
      const currentPerformers = state.livePerformers?.data?.result || [];
      const fetchedPerformers =
        action.data && action.data.result ? action.data.result : [];
      return {
        ...state,
        livePerformers: {
          data: {
            ...action.data,
            result: mergeUnique(currentPerformers, fetchedPerformers),
          },
          error: false,
          loading: false,
        },
      };
    case FETCH_LIVE_PERFORMERS_FAILURE:
      return {
        ...state,
        livePerformers: {
          ...state.livePerformers,
          loading: false,
          error: action.error,
        },
      };
    case FETCH_LIVE_STREAMING_SUMMARY_START:
      return {
        ...state,
        summary: {
          data: {},
          error: false,
          loading: true,
        },
      };
    case FETCH_LIVE_STREAMING_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: {
          data: action.data,
          error: false,
          loading: false,
        },
      };
    case FETCH_LIVE_STREAMING_SUMMARY_FAILURE:
      return {
        ...state,
        summary: {
          data: null,
          error: action.data,
          loading: false,
        },
      };
    case ADD_LIVE_STREAMING_TIP_PAYMENT:
      return {
        ...state,
        tipAnimations: {
          payments: [ ...state.tipAnimations.payments, action.data ]
        },
      };
    case REMOVE_LIVE_STREAMING_TIP_PAYMENT:
      return {
        ...state,
        tipAnimations: {
          payments: state.tipAnimations.payments.filter((item) => item.paymentId !== action.data)
        },
      };
    default:
      return state;
  }
};

export default StreamingReducer;
